import { render, staticRenderFns } from "./normalGoodsProfitUpload.vue?vue&type=template&id=3cf9bdc2"
import script from "./normalGoodsProfitUpload.vue?vue&type=script&lang=js"
export * from "./normalGoodsProfitUpload.vue?vue&type=script&lang=js"
import style0 from "./normalGoodsProfitUpload.vue?vue&type=style&index=0&id=3cf9bdc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports